// <s-footer-contact> — remembers which footer form (feedback / jobs) was sent and, after the
// contact form reloads the page, reopens that dialog so the customer sees the success or error message.
// One component per file.
const STORAGE_KEY = "petslife-footer-contact";

class SFooterContact extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const kind = this.dataset.kind;
    const form = this.querySelector("form");
    form?.addEventListener(
      "submit",
      () => {
        try {
          sessionStorage.setItem(STORAGE_KEY, kind);
        } catch (_) {
          /* storage unavailable: the message still sends */
        }
      },
      { signal: this.#ac.signal },
    );

    let lastKind = null;
    try {
      lastKind = sessionStorage.getItem(STORAGE_KEY);
    } catch (_) {
      lastKind = null;
    }
    if (lastKind !== kind) return;
    if (!this.querySelector("[data-footer-contact-result]")) return;

    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {
      /* ignore */
    }
    const dialog = this.querySelector("dialog");
    if (dialog && !dialog.open) dialog.showModal();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get("s-footer-contact")) {
  customElements.define("s-footer-contact", SFooterContact);
}
